export function handleTextShortcuts (event, canChangeDecoration, isMacLike) {
  isMacLike = isMacLike || /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
  const isCtrlKey = isMacLike ? event.metaKey : event.ctrlKey;
  const editor = INKIVE.Tool.getInstance().editor;
  const action = getAction(isCtrlKey, event.code);
  if (!isCtrlKey) return action;

  const handleTextStyle = (action) => {
    canChangeDecoration && document.querySelector(`.btn-onmenu[data-action="on_set-${action}"]`).click();
  };

  switch (event.code) {
    case 'KeyB':
    case 'KeyI':
    case 'KeyU':
      event.preventDefault();
      handleTextStyle(action);
      break;
    case 'Enter':
      editor && editor.setMode('select');
  }
  return action;
}

export const keyCodeActions = {
  KeyB: 'bold',
  KeyI: 'italic',
  KeyU: 'underline',
  Enter: 'end'
};

function getAction (isCtrlKey, eventCode) {
  if (!isCtrlKey) return 'none';
  return keyCodeActions[eventCode] || 'none';
}

export function shouldAvoidShortcuts (target) {
  if (!target) return true;

  return target instanceof HTMLInputElement ||
    target.type === 'input' ||
    target.type === 'textarea' ||
    target.classList.contains('avoid-shortcuts');
}
